module.exports = "/_next/static/images/percentage-b3d7b983bc53528e6035267ec676b197.svg";